import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { ChangeRequestEffects } from './store/effects/change-request.effects'
import { ChangeRequestChangesEffects } from './store/effects/change-request-changes.effects'
import { ChangeRequestDeliverableEffects } from './store/effects/change-request-deliverable.effects'
import { ChangeRequestComponentEffects } from './store/effects/change-request-component.effects'
import { ChangeRequestFeeEffects } from './store/effects/change-request-fee.effects'
import { ChangeRequestSectionEffects } from './store/effects/change-request-section.effects'
import { ChangeRequestFlowEffects } from './store/effects/change-request-flow.effects'

const EFFECTS = [
  ChangeRequestEffects,
  ChangeRequestChangesEffects,
  ChangeRequestDeliverableEffects,
  ChangeRequestComponentEffects,
  ChangeRequestFeeEffects,
  ChangeRequestSectionEffects,
  ChangeRequestFlowEffects,
]

@NgModule({ imports: [EffectsModule.forFeature(EFFECTS)] })
export class ChangeRequestNgrxModule {}
